export const EXTENSION_ID =
  window.location.host === "app.prospectin.fr"
    ? "ohmpcdmgbjhkhnljkaeeahndchboiici"
    : "aohghmighlieiainnegkcijnfilokake";
